import {useQueryParamValue} from '@hconnect/common/hooks'

import {PLANT_STATUS_DEFAULT_TIME_RANGE, KEY_TIME_RANGE} from '../consts'

export const usePlantStatusPageParams = () => {
  const [timeRangeParam, setTimeRangeParam] = useTimeRangeParam()

  return {
    timeRangeParam,
    setTimeRangeParam
  }
}

const useTimeRangeParam = (): [string, (value: string) => void] => {
  const [timeRange, setTimeRange] = useQueryParamValue<string>(KEY_TIME_RANGE, {
    keepInLocalStorage: true
  })

  return [timeRange || PLANT_STATUS_DEFAULT_TIME_RANGE, setTimeRange]
}
